import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useToast } from '../../context/ToastContext';
import { errMsg } from '../../utils/errMsg';
import getSubdomain from '../../utils/getSubdomain';
import buttons from '../../styles/shared/buttons.module.css';

function buildSignupUrl(group, organizationSlug) {
  const subdomain = getSubdomain();
  return subdomain
    ? `${window.location.origin}/${group.id}`
    : `${window.location.origin}/o/${organizationSlug}/g/${group.id}`;
}

export default function GroupQrDialog({ group, organizationSlug, onHide }) {
  const [dataUrl, setDataUrl] = useState(null);
  const showToast = useToast();

  useEffect(() => {
    if (!group) {
      setDataUrl(null);
      return;
    }
    const url = buildSignupUrl(group, organizationSlug);
    QRCode.toDataURL(url, { width: 280, margin: 2 })
      .then(setDataUrl)
      .catch((err) => showToast('error', 'QR code', errMsg(err, 'Could not generate QR code.')));
  }, [group, organizationSlug, showToast]);

  function handleDownload() {
    const a = document.createElement('a');
    a.href = dataUrl;
    const filename = group.name.trim().toLowerCase().replace(/\s+/g, '-') || 'group';
    a.download = `${filename}-signup-qr.png`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  async function handleCopyLink(url) {
    try {
      await navigator.clipboard.writeText(url);
      showToast('success', 'QR code', 'Link copied to clipboard.');
    } catch (err) {
      showToast('error', 'QR code', errMsg(err, 'Could not copy link.'));
    }
  }

  return (
    <Dialog
      header={`QR code${group ? ` — ${group.name}` : ''}`}
      visible={Boolean(group)}
      onHide={onHide}
      style={{ width: '400px', maxWidth: '90vw' }}
      modal
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
        {dataUrl && (
          <img
            src={dataUrl}
            alt="Signup QR code"
            style={{ width: 'clamp(130px, 36vh, 280px)', height: 'clamp(130px, 36vh, 280px)' }}
          />
        )}
        {group && (
          <p
            className="textMuted"
            title="Click to copy"
            style={{ textAlign: 'center', wordBreak: 'break-all', cursor: 'pointer' }}
            onClick={() => handleCopyLink(buildSignupUrl(group, organizationSlug))}
          >
            {buildSignupUrl(group, organizationSlug)}
          </p>
        )}
        <Button
          label="Download"
          icon="pi pi-download"
          className={buttons.saveBtn}
          disabled={!dataUrl}
          onClick={handleDownload}
        />
      </div>
    </Dialog>
  );
}
